import React from 'react';

const Footer = () => (
  <footer
    style={{
      color: '#f39502',
      background: '#2d2d2d',
    }}
  >
  <div
    style={{
      margin: `0 auto`,
      maxWidth: 960,
      padding: '0.45rem 0',
    }}
    >
    © {new Date().getFullYear()}, Source Shaper Ltd
    </div>
  </footer>
);

export default Footer;
